import React from "react";
import Select, { components } from "react-select";
import Text from "../typography/Text";
import Icon from "@mdi/react";
import { mdiCheck, mdiChevronDown } from "@mdi/js";

export default ({
  width = "10rem",
  options = [],
  label,
  selected,
  required,
  adaptable,
  setSelected,
  placeholder = "",
  error,
}) => {
  return (
    <label className={`select ${error ? "-error" : ""}`}>
      {label && (
        <div className="select_label">
          {label} {required && <span className="select_required">*</span>}
        </div>
      )}
      <Select
        value={selected}
        onChange={selection => setSelected(selection)}
        options={options}
        className={`select_select ${!!selected ? "-hasValue" : "-empty"}`}
        classNamePrefix="select"
        placeholder={placeholder}
        styles={{
          control: (provided, state) =>
            adaptable
              ? {
                  ...provided,
                  width: selected
                    ? `calc(${selected.label.length} * 9.5px + 40px)`
                    : width,
                  minWidth: selected ? "125px" : 0,
                }
              : provided,
          menu: (provided, state) => ({
            ...provided,
            width: "200px",
          }),
        }}
        components={{ Option, IndicatorSeparator: null, DropdownIndicator }}
      ></Select>
    </label>
  );
};

const Option = ({ label, isSelected, innerProps, isDisabled }) => {
  return (
    <div
      {...innerProps}
      className={`select_option ${isSelected ? "-selected" : ""}`}
    >
      {isSelected ? (
        <span className="select_checkmark -selected">
          <Icon path={mdiCheck} color="white" size={"16px"} />
        </span>
      ) : (
        <span className="select_checkmark" />
      )}
      <Text small>{label}</Text>
    </div>
  );
};

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <Icon path={mdiChevronDown} color="#ff4d3b" size="24px" />
  </components.DropdownIndicator>
);
